import React, { createContext, useState, useEffect, useCallback, useContext } from 'react';
import { getobtenercEstadoContratos } from '../API/ApiEstadosDeContrato';
import { AuthContext } from '../auth/authContext';

const EstadosContratoContext = createContext(null);

export function EstadosContratoProvider({ children }) {
    const [estadosContrato, setEstadosContrato] = useState([]);
    const { user, dispatch } = React.useContext(AuthContext);
    useEffect(() => {
        getobtenercEstadoContratos(user, {}).then(resultado => {
            if (resultado && resultado.data) {
                setEstadosContrato(resultado.data);
            }
        })
    }, []);

    return (
        <EstadosContratoContext.Provider value={{ estadosContrato }}>
            {children}
        </EstadosContratoContext.Provider>
    );
}

export function useEstadosContrato() {
    const ctx = useContext(EstadosContratoContext);
    if (!ctx) {
        throw new Error('useEstadosContrato must be used within an EstadosContratoProvider');
    }
    return ctx;
}

export default EstadosContratoContext;